module.exports = __webpack_public_path__ + "img/bg_resize_castle_middle_roof.532ce30b.webp";